<template>
  <router-link
    tag="div"
    class="all-product-section gold-product-card"
    :to="{path:`/product/${goldItems.product_id}`}"
  >
    <div class="product-img">
      <img :src="goldItems.media_images" v-if="goldItems.media_images" />
      <img src="../assets/images/thumbnail-default.jpg" v-else />
    </div>
    <div class="gld-pro-detail">
      <div class="user-gld-gram">{{goldItems.description}}</div>
      <div class="user-txt">{{$t('constructionfee')}}</div>
      <div class="user-gld-price">
        <span class="gold_rate">₹{{goldItems.minting_cost}}</span>
      </div>
    </div>
  </router-link>
</template>
<script>
import GoldProducts from "../components/GoldProducts";
import { mapGetters } from "vuex";
import types from "../store/types";

export default {
  props: {
    goldItems: Object,
    require: true
  }
};
</script>
